// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hyoP","comment":"styles_comment__1-kFE"};